export { default } from './Settings2FA.jsx';
